module.exports = __webpack_public_path__ + "img/360.85231e74.svg";